import './GlassButton.css';

const GlassButton = ({ children, onClick, className = '' }) => {
  return (
    <button 
      className={`glass-button ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default GlassButton;